var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.desktop)?_c('div',{staticClass:"d-none d-md-block"},[_c('GoogleAdsPopup',{staticStyle:{"margin":"0 auto"},attrs:{"path":"/22163595876/RTBGo_Interstitial_Web","size":[1, 1],"id":"RTBGo_Interstitial_Web"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }